var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 h-100 flex flex-column"},[_c('dv-border-box-12',[_c('div',{staticClass:"h-100"},[_c('div',{staticClass:"w-100 h-100 p-tb",attrs:{"id":"issueCloseRate"}})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e8ada7c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href","audio":"src"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/fr/report/8d/component/issue-close-rate.vue
// module id = null
// module chunks = 